import React, { useState, useEffect } from "react"
import { Slider } from "@material-ui/core"
import ProductPreview from "../ProductPreview/ProductPreview"
import CustomItemPreview from "../ItemPreview/CustomItemPreview"
import ContributionPreview from "../ProductPreview/ContributionPreview"
import { useHistory } from "react-router-dom"
import CustomAmountInput from "./CustomAmountInput"

const CustomerRegistryItems = ({
  products,
  categories,
  minProductPrice,
  maxProductPrice,
  contributions
}) => {
  const [filterProducts, setFilterProducts] = useState([])
  const [priceValue, setPriceValue] = useState([
    minProductPrice,
    maxProductPrice
  ])
  const [customAmount, setCustomAmount] = useState(false)
  const history = useHistory()

  useEffect(() => {
    setFilterProducts(products)
    setPriceValue([minProductPrice, maxProductPrice])
  }, [products, minProductPrice, maxProductPrice])

  const handleValueChange = (event, newValue) => {
    setPriceValue(newValue)
    setFilterProducts(
      products.filter(
        p =>
          p.product.sales_price >= newValue[0] &&
          p.product.sales_price <= newValue[1]
      )
    )
  }

  return (
    <div className="registry__page-wrapper py-20 mobiles:py-5 global-container">
      {customAmount && (
        <CustomAmountInput
          closeModal={() => setCustomAmount(false)}
          handleSuccess={() => {
            history.push("/cash-checkout")
          }}
        />
      )}
      <section className="flex">
        <div className="w-96 mobiles:hidden self-start p-5 mr-8 shadow rounded-md">
          <div className="py-4 border-b-2 border-gray-200 mb-2">
            <p className="text-gray-600">Multi Range</p>
            <div className="flex justify-between w-full mt-3 mb-6">
              <h2 className="text-gray-600 text-xs">{minProductPrice}</h2>
              <h2 className="text-gray-600 text-xs">{maxProductPrice}</h2>
            </div>

            <Slider
              valueLabelDisplay="auto"
              classes={{
                root: "slider-root",
                thumb: "slider-thumb",
                valueLabel: "slider-value-label",
                track: "slider-track",
                rail: "slider-rail"
              }}
              value={priceValue}
              min={minProductPrice}
              max={maxProductPrice}
              onChange={handleValueChange}
            />
          </div>

          {categories.map((c, i) => (
            <div
              className="flex w-full items-center justify-between mb-2"
              key={i}
            >
              <input
                type="radio"
                className="w-1/12"
                name="category"
                onChange={() =>
                  setFilterProducts(
                    products.filter(p => p.product?.category[0] === c._id)
                  )
                }
              />
              <p className="w-10/12 text-sm text-gray-500">{c.name}</p>
            </div>
          ))}

          <div className="mt-5">
            <button
              style={{ backgroundColor: "#6F64F8", fontSize: "11px" }}
              className="px-3 block py-3 w-full text-center text-white rounded-bl-md"
              onClick={() => setFilterProducts(products)}
            >
              CLEAR ALL FILTERS
            </button>
          </div>
        </div>

        <div>
          <div className="my-5 flex items-center justify-end">
            <img
              src={require("../../assets/money-bag.svg").default}
              alt=""
              className="h-9"
            />

            <button
              onClick={() => {
                setCustomAmount(true)
              }}
              className=" py-2.5 px-11 bg-sbg-light-green text-transparent ml-5 rounded-lg text-base text-white mr-6 focus:outline-none"
            >
              Gift Cash
            </button>
          </div>

          <div className="flex-1 mobiles:w-full mobiles:grid-cols-2 mobiles:gap-4 grid grid-cols-3 gap-10">
            {contributions?.map((c, i) => (
              <ContributionPreview {...c} key={i} />
            ))}

            {!!products &&
              filterProducts?.map((product, i) => (
                <ProductPreview
                  product={product}
                  key={i}
                  // registryId={registryId}
                  //   handleDelete={() => DeleteProduct(product?.product._id)}
                />
              ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default CustomerRegistryItems
